/**
 * Vegas Sweets Expo — hero unmute, carousel nudge, segmented form visibility.
 * Expects root: [data-vse-root]
 */
(function () {
  'use strict';

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function getHeroVideo(root) {
    var wrap = qs(root, '.vse-hero__media-wrap--crunch');
    if (!wrap) return null;
    return wrap.querySelector('video');
  }

  function toggleCrunchSound(video) {
    if (!video) return;

    if (video.muted) {
      video.muted = false;
      video.volume = 1;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    } else {
      video.muted = true;
    }
  }

  function initHero(root) {
    var video = getHeroVideo(root);
    var mediaWrap = qs(root, '.vse-hero__media-wrap--crunch');

    if (!video || !mediaWrap) return;

    mediaWrap.addEventListener('click', function () {
      toggleCrunchSound(video);
    });
  }

  function initCarousel(root) {
    var track = qs(root, '[data-vse-carousel]');
    if (!track) return;

    var prev = qs(root, '[data-vse-carousel-prev]');
    var next = qs(root, '[data-vse-carousel-next]');
    var card = qs(root, '[data-vse-product-card]');

    function scrollByDir(dir) {
      var delta = 280;
      if (card) delta = card.getBoundingClientRect().width + 16;
      track.scrollBy({ left: dir * delta, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
    if (next) next.addEventListener('click', function () { scrollByDir(1); });
  }

  function initForm(root) {
    var form = qs(root, '.vse-lead-form');
    if (!form) return;

    var typeSelect = qs(form, '[data-vse-inquiry-type]');
    var retailer = qs(form, '[data-vse-fields-retailer]');
    var influencer = qs(form, '[data-vse-fields-influencer]');
    var other = qs(form, '[data-vse-fields-other]');

    function setRequired(fieldset, on) {
      if (!fieldset) return;
      qsa(fieldset, 'input, textarea, select').forEach(function (el) {
        if (el.hasAttribute('data-vse-required-when-active')) {
          el.required = on;
        }
      });
    }

    function setFieldsetActive(fs, active) {
      if (!fs) return;
      fs.hidden = !active;
      qsa(fs, 'input, textarea, select').forEach(function (el) {
        el.disabled = !active;
      });
    }

    function applyType() {
      var v = typeSelect ? typeSelect.value : 'Other';
      setFieldsetActive(retailer, v === 'Retailer');
      setFieldsetActive(influencer, v === 'Influencer');
      setFieldsetActive(other, v === 'Other');

      setRequired(retailer, v === 'Retailer');
      setRequired(influencer, v === 'Influencer');
      setRequired(other, v === 'Other');
    }

    if (typeSelect) {
      typeSelect.addEventListener('change', applyType);
      applyType();
    }

    form.addEventListener('submit', function () {
      var hiddenBody = qs(form, '[data-vse-body-composer]');
      if (!hiddenBody) return;

      var lines = [];
      lines.push('Inquiry type: ' + (typeSelect ? typeSelect.value : ''));
      qsa(form, 'input:not([type="hidden"]), textarea, select').forEach(function (el) {
        if (el === hiddenBody) return;
        if (el.name === 'inquiry_type') return;
        if (el.name === 'form_type' || el.name === 'utf8') return;
        if (el.type === 'submit') return;
        if (el.disabled) return;
        if (!el.name || el.value === '') return;
        var label = el.getAttribute('aria-label') || el.name;
        lines.push(label + ': ' + el.value);
      });
      hiddenBody.value = lines.join('\n');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    qsa(document, '[data-vse-root]').forEach(function (root) {
      initHero(root);
      initCarousel(root);
      initForm(root);
    });
  });
})();
